<template>
  <div class="skeleton-cart">
    <div class="skeleton-footer">
      <div class="skeleton-total shimmer"></div>
      <div class="skeleton-button shimmer"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartSkeletonFooter",
};
</script>

<style scoped>
.skeleton-cart {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}

.skeleton-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  box-shadow: 0 -4px 10px rgba(0,0,0,0.1);
}

.skeleton-total {
  width: 30%;
  height: 18px;
  border-radius: 6px;
  background: #f0f0f0;
}

.skeleton-button {
  width: 120px;
  height: 38px;
  border-radius: 25px;
  background: #e0e0e0;
}

.shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s linear infinite;
}

@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
</style>
